import React, { SFC } from "react";
import { Button, Paragraph } from "scuid-x";
import { CaptureTipOrderState, CaptureTips } from "../../constants/CameraTips";
import { DocExamples } from "../../constants/DocExamples";
import { DocType } from "../../constants/DocType";
import "./CaptureInstructions.css";

export interface CaptureInstructionsProps {
  currentIndex: number;
  docType: DocType;
  gotItClick: () => void;
  numberOfDocs: number;
}

export const CaptureInstructions: SFC<CaptureInstructionsProps> = (props: CaptureInstructionsProps) => {
  const docType = props.docType;

  const exampleImage = DocExamples.getFirstByDocType(docType);
  let img = (null);
  if (!!exampleImage) {
    img = (
      <img
        className={"CaptureInstructions-example-image"}
        src={exampleImage.info.image}
        alt={exampleImage.info.title}
      />
    );
  }

  let orderState;
  if (props.numberOfDocs === 1) {
      orderState = CaptureTipOrderState.SINGLE;
  } else if (props.currentIndex > 0) {
      orderState = CaptureTipOrderState.NOT_FIRST;
  } else {
      orderState = CaptureTipOrderState.FIRST;
  }

  const tip = CaptureTips.getFilledTips (props.docType, orderState);
  let text = (null);
  if (!!tip) {
    text = <Paragraph>{tip}</Paragraph>;
  }

  return (
    <div className={"CaptureInstructions-container"}>
      {img}
      <div className={"CaptureInstructions-info-box"}>
        {text}
        <Button onClick={props.gotItClick}>Got it</Button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/doc-capture/CaptureInstructions.tsx